<div *ngIf="headerTemplate">
  <ng-container
    *ngTemplateOutlet="
      headerTemplate;
      context: {
        appConfiguration: appConfiguration,
        pageConfig: pageConfig,
        nextButtonLabel: nextButtonLabel,
        backButtonLabel: backButtonLabel,
        navigate: navigateCallback,
        navigateNext: navigateNextCallback,
        navigateBack: navigateBackCallback,
        labelCondition: labelCondition,
        pageStatus: pageStatus,
        errorMessage: errorMessage,
        noConfig: noConfig,
        navigationOrServiceActivatorInProgress: navigationOrServiceActivatorInProgress
      }
    "
  ></ng-container>
</div>

<div *ngIf="errorMessageTemplate">
  <ng-container
    *ngTemplateOutlet="
      errorMessageTemplate;
      context: {
        appConfiguration: appConfiguration,
        pageConfig: pageConfig,
        nextButtonLabel: nextButtonLabel,
        backButtonLabel: backButtonLabel,
        navigate: navigateCallback,
        navigateNext: navigateNextCallback,
        navigateBack: navigateBackCallback,
        labelCondition: labelCondition,
        pageStatus: pageStatus,
        errorMessage: errorMessage,
        noConfig: noConfig,
        navigationOrServiceActivatorInProgress: navigationOrServiceActivatorInProgress
      }
    "
  ></ng-container>
</div>

<div *ngIf="noConfigMessageTemplate">
  <ng-container
    *ngTemplateOutlet="
      noConfigMessageTemplate;
      context: {
        appConfiguration: appConfiguration,
        pageConfig: pageConfig,
        nextButtonLabel: nextButtonLabel,
        backButtonLabel: backButtonLabel,
        navigate: navigateCallback,
        navigateNext: navigateNextCallback,
        navigateBack: navigateBackCallback,
        labelCondition: labelCondition,
        pageStatus: pageStatus,
        errorMessage: errorMessage,
        noConfig: noConfig,
        navigationOrServiceActivatorInProgress: navigationOrServiceActivatorInProgress
      }
    "
  ></ng-container>
</div>

<div *ngIf="pageOutlet">
  <ng-container
    *ngTemplateOutlet="
      pageOutlet;
      context: {
        appConfiguration: appConfiguration,
        pageConfig: pageConfig,
        nextButtonLabel: nextButtonLabel,
        backButtonLabel: backButtonLabel,
        navigate: navigateCallback,
        navigateNext: navigateNextCallback,
        navigateBack: navigateBackCallback,
        labelCondition: labelCondition,
        pageStatus: pageStatus,
        errorMessage: errorMessage,
        noConfig: noConfig,
        navigationOrServiceActivatorInProgress: navigationOrServiceActivatorInProgress
      }
    "
  ></ng-container>
</div>

<div *ngIf="navigationTemplate" [@.disabled]="!!pageConfig?.disableAnimations" [@routeAnimations]="pageConfig?.pageId">
  <ng-container
    *ngTemplateOutlet="
      navigationTemplate;
      context: {
        appConfiguration: appConfiguration,
        pageConfig: pageConfig,
        nextButtonLabel: nextButtonLabel,
        backButtonLabel: backButtonLabel,
        navigate: navigateCallback,
        navigateNext: navigateNextCallback,
        navigateBack: navigateBackCallback,
        labelCondition: labelCondition,
        pageStatus: pageStatus,
        errorMessage: errorMessage,
        noConfig: noConfig,
        navigationOrServiceActivatorInProgress: navigationOrServiceActivatorInProgress
      }
    "
  ></ng-container>
</div>

<div *ngIf="footerTemplate">
  <ng-container
    *ngTemplateOutlet="
      footerTemplate;
      context: {
        appConfiguration: appConfiguration,
        pageConfig: pageConfig,
        nextButtonLabel: nextButtonLabel,
        backButtonLabel: backButtonLabel,
        navigate: navigateCallback,
        navigateNext: navigateNextCallback,
        navigateBack: navigateBackCallback,
        labelCondition: labelCondition,
        pageStatus: pageStatus,
        errorMessage: errorMessage,
        noConfig: noConfig,
        navigationOrServiceActivatorInProgress: navigationOrServiceActivatorInProgress
      }
    "
  ></ng-container>
</div>
